import type { ReactNode } from 'react';

export const symbol_pip_exit: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-270q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v270h680v-520H470q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h350q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm407-290 129 129q9 9 21 9t21-9.05q9-9.06 9-21.5 0-12.45-9-21.45L589-493h88q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H517q-12.75 0-21.37 8.62Q487-535.75 487-523v160q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-87ZM110-580q-12.75 0-21.37-8.63Q80-597.25 80-610v-160q0-12.75 8.63-21.38Q97.25-800 110-800h240q12.75 0 21.38 8.62Q380-782.75 380-770v160q0 12.75-8.62 21.37Q362.75-580 350-580H110Zm370 100Z"
		/>
	</svg>
);
